import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./Pages/Home";
import GlobalModal from "./components/GlobalModal";
import PortectedArea from "./Pages/PortectedArea";
import Accomodation from "./Pages/Accomodation";
import Gastronomy from "./Pages/Gastronomy";
import Activities from "./Pages/Activities";
import Carnaval from "./Pages/Carnaval";
import Gallery from "./Pages/Gallery";
import Entrepreneurs from "./Pages/Entrepreneurs";
import Contact from "./Pages/Contact";
import ScrollToTop from "./Helpers/ScrollToTop";
import Footer from "./components/Footer";
import Auth from "./components/Auth";
import AdminPanel from "./Pages/Admin/AdminPanel";
import { useUser } from "./Contexts/UserContext";
import Error from "./components/Error";
import ProtectedRoute from "./Middlewares/ProtectedRoute";
import WeatherWidget from "./components/WeatherWidget";
import Artigas from "./Pages/Artigas";

const Router = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/area-protegida" element={<PortectedArea />} />
        <Route exact path="/alojamiento" element={<Accomodation />} />
        <Route exact path="/gastronomia" element={<Gastronomy />} />
        <Route exact path="/actividades" element={<Activities />} />
        <Route exact path="/carnaval" element={<Carnaval />} />
        <Route exact path="/galeria" element={<Gallery />} />
        <Route exact path="/emprendimientos" element={<Entrepreneurs />} />
        <Route exact path="/contacto" element={<Contact />} />
        <Route exact path="/artigas" element={<Artigas />} />
        <Route exact path="/ingresar" element={<Auth />} />

        {/* ADMIN ROUTES */}
        <Route
          exact
          path="/admin/panel-de-control"
          element={
            <ProtectedRoute role="admin">
              <AdminPanel />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer />
      <GlobalModal />
    </BrowserRouter>
  );
};

export default Router;
